InlineVariations = window.InlineVariations ?= {}
InlineVariations.Collections ?= {}
InlineVariations.Models ?= {}
InlineVariations.Models.Trait = require '../models/trait'

InlineVariations.Collections.Traits = Backbone.Collection.extend
  model: InlineVariations.Models.Trait
  selectedTraitValues: {}

  initialize: ->
    @on 'change:selectedTraitValue', @changeSelectedTraitValue, this

  changeSelectedTraitValue: (model, val) ->
    if val
      @selectedTraitValues[model.get('name')] = val
    else
      delete @selectedTraitValues[model.get('name')]

  someTraitValuesSelected: ->
    _.keys(@selectedTraitValues).length > 0

  allTraitValuesSelected: ->
    _.keys(@selectedTraitValues).length is @models.length

  closeDropdowns: ->
    for trait in @models
      trait.view.closeDropdown()

module.exports = InlineVariations.Collections.Traits
